import httpClient from '@/http-client'
import { baseMutations, baseState } from '@/store/mixins'

// Assuming your API endpoint structure is aligned with the routes you showed earlier.
const BASE_URL = '/api/v2/class-attendances'

export default {
  namespaced: true,
  state: {
    ...baseState,
    termList: []
  },
  mutations: {
    ...baseMutations,
    SET_TERM_LIST(state, data) {
      state.termList = data
    }
  },
  actions: {
    fetch(context, attributes = {}) {
      return httpClient
        .get(`${BASE_URL}/get-student-by-classes`, { params: attributes })
        .then(response => {
          return Promise.resolve(response)
        })
    },

    store(context, data) {
      return httpClient.post(`${BASE_URL}/attendance-submits`, data)
    },

    async dataBeforeCreate(context) {
      let response = await httpClient.get(`${BASE_URL}/form-view-models`, {
        params: {
          fnName: 'academic_term'
        }
      })

      Object.keys(response.data.data).forEach(key => {
        if (key == 'academic_term') {
          context.commit('SET_TERM_LIST', response.data.data[key])
        }
      })
    },

    async getClass(context, ac_term_id) {
      let response = await httpClient.get(`${BASE_URL}/form-view-models`, {
        params: {
          fnName: 'getClass',
          ac_term_id
        }
      })
      return {
        data: response.data.data.getClass
      }
    },

    async getTeacher(context, class_id) {
      let response = await httpClient.get(`${BASE_URL}/form-view-models`, {
        params: {
          fnName: 'getTeacher',
          class_id
        }
      })
      return {
        data: response.data.data.getTeacher
      }
    },

    async getSubjectByTeacher(context, { class_id, teacher_id }) {
      let response = await httpClient.get(`${BASE_URL}/form-view-models`, {
        params: {
          fnName: 'getSubjectByTeacher',
          class_id,
          teacher_id
        }
      })
      return {
        data: response.data.data.getSubjectByTeacher
      }
    }
  }
}
